import { render, staticRenderFns } from "./BikePicture.vue?vue&type=template&id=58d186ec&scoped=true&"
import script from "./BikePicture.vue?vue&type=script&lang=js&"
export * from "./BikePicture.vue?vue&type=script&lang=js&"
import style0 from "./BikePicture.vue?vue&type=style&index=0&id=58d186ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d186ec",
  null
  
)

export default component.exports